<script>
	import Counters from "./Counters.svelte";
	import { onMount } from "svelte";

	export let allcounters; // pic is [[{v:2},{v:0},{v:4},....] ,[{v:2},{v:0},{v:4},....],[{v:2},{v:0},{v:4},....],...]
	let allcounterssum = 0;

	//init sum of all counters
	onMount(() => {
		allcounters.forEach((item) => {
			item.forEach((inneritem) => {
				allcounterssum += parseInt(inneritem.v);
			});
		});
	});

	const onAllValChangeHandler = (event) => {
		allcounterssum += parseInt(event.detail.val);
	};
</script>

<div>
	<h2>{allcounterssum}</h2>
	{#each allcounters as cnts}
		<Counters counters={cnts} on:chvalall={onAllValChangeHandler} />
	{/each}
</div>

<style>
	div {
		width: 25%;
		padding: 12px;
        margin:auto;
        margin-top:30px;
		background-color: rgb(80, 180, 247);
		border-radius: 12px;
	}
	h2 {
		position: relative;
		width: 95%;
		border: 1px solid black;
		border-radius: 30px;
		background-color: rgb(106, 255, 163);
		color: rgb(2, 0, 99);
		padding: 6px;
		margin: auto;
		margin-bottom: 12px;
		text-align: center;
		font-weight: bold;
		font-size: 36px;
	}
</style>
